module.exports = {
  DEFAULT_PROJECTION: 'mercator',
  DEFAULT_STYLE: 'Terrain',
  DEFAULT_DARK_FEATURE_COLOR: '#555',
  DEFAULT_LIGHT_FEATURE_COLOR: '#e8e8e8',
  DEFAULT_SATELLITE_FEATURE_COLOR: '#00f900',
  API_TOKEN: 'pk.eyJ1IjoiZGVuaGFtcyIsImEiOiJjbTM3cGNlZTcwanljMmpvbXN2cHhudjVnIn0.vhsxAr3YEQIMaZmjmu2X9A'
};
